import React from 'react';
import ArticleSideBar from '../article/ArticleSideBar';
import ContentHubBreadcrumbs from './ContentHubBreadcrumbs';
import {
  ContentHubContentWrapper,
  ContentHubMainContent,
  ContentHubMainContentContainer,
  ContentHubMainContentWrapper,
} from './ContentHubContentContainer.style';
import { ContentHubPageContainerProps } from './ContentHubPageContainer';

interface ContentHubContentContainerProps extends ContentHubPageContainerProps {}

const ContentHubContentContainer: React.FC<ContentHubContentContainerProps> = ({
  children,
  breadcrumbs,
  showSidebar,
  sidebarData,
}) => {
  return (
    <ContentHubContentWrapper>
      <ContentHubMainContent data-testid="article-main-content" id="article-container">
        <ContentHubMainContentContainer>
          <ContentHubMainContentWrapper>
            {breadcrumbs && <ContentHubBreadcrumbs breadcrumbs={breadcrumbs} />}
            {children}
          </ContentHubMainContentWrapper>
          {showSidebar && <ArticleSideBar {...sidebarData} />}
        </ContentHubMainContentContainer>
      </ContentHubMainContent>
    </ContentHubContentWrapper>
  );
};

export default ContentHubContentContainer;
